import React from 'react';

interface WideLayoutProps {
	cropperContent: React.ReactNode;
}

/**
 * Wide Layout - Full width single column for maximum workspace
 * Use case: Email editor, design tools requiring precision
 */
export const WideLayout: React.FC<WideLayoutProps> = ({ cropperContent }) => {
	return <div id="bay-image-crop-wide-layout">{cropperContent}</div>;
};

export default WideLayout;
